import React from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";
import FilterBtn from "../../../../components/Universal/FilterBtn.component";
import { Helmet } from "react-helmet";
import Title from "../../../../components/Universal/Title.component";
import AdmissionOverviewGraph from "../../../../components/PagesComponents/Operational/Academic/Admission/AdmissionOverviewGraph.component";
import GraphToolTip from "../../../../components/Universal/GraphLegends.component";

import SearchBtnIcon from "../../../../assets/Icons/Universal/Search.svg";
import CrossHoloIcon from "../../../../assets/Icons/Universal/CrossHoloIcon.svg";
import TickHoloIcon from "../../../../assets/Icons/Universal/GreenTickHolo.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";
import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import ProfileImage from "../../../../assets/Images/TestImg/profileImage.png";
import Image from "../../../../components/Universal/Image.component";
const Body = ({
  filter,
  setFilter,
  classesFilter,
  setClassesFilter,
  yearFilter,
  setYearFilter,
  chartData,
}) => {
  return (
    <section className="flex-col aligm-start justify-start g-1 pr-1">
      <Helmet>
        <title>Admission</title>
        <meta
          name="keywords"
          content="admission student, admission dashboard"
        />
        <meta
          name="description"
          content="better visualization of student admission"
        />
      </Helmet>
      <PageHeader
        renderCustomElement={
          <div className="flex-row align-center justify-start g-05">
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="All"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Boys"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Girls"
            />
            <FilterBtn
              btnTitle={"Filter"}
              filterArray={[
                "Class I",
                "Class II",
                "Class III",
                "Class IV",
                "Class V",
              ]}
              setFilteredData={(val) => setClassesFilter(val)}
              filteredData={classesFilter}
            />
            <div className="searchInputContainer">
              <input
                type="text"
                className="pageHeaderInput"
                placeholder="Type for search"
              />
              <button className="searchBtn">
                <img src={SearchBtnIcon} alt="searchBtn" />
              </button>
            </div>
          </div>
        }
      />

      <div className="flex align-start justify-start scroll-x">
        <div className="flex-row align-center justify-start g-05">
          {[...Array(10)].map((_, i) => {
            const year = new Date().getFullYear() - i;
            return (
              <TogglePushBtn
                key={year}
                type="checkbox"
                setVal={() =>
                  setYearFilter(
                    (prev) =>
                      prev.includes(year)
                        ? prev.filter((y) => y !== year) // remove if already selected
                        : [...prev, year] // add if not selected
                  )
                }
                name={filter?.year}
                value={yearFilter.includes(year) ? year.toString() : ""}
                label={year.toString()}
                btnStyle={{ padding: "1.2rem 2rem", width: "6.5rem" }}
                lableStyle={{ fontSize: "14px" }}
              />
            );
          })}
        </div>
      </div>

      <div className="h-fit w-full flex-col align-start justify-start g-1 back-white radius-10 p-1">
        <div className="flex-row align-center justify-between">
          <Title>Class wise admission and re-admission</Title>
          <div className="flex-row align-center justify-between g-2">
            <GraphToolTip color={"#FFECA0"} label={"Vaccant"} />
            <GraphToolTip color={"#BDD0AE"} label={"Vaccant"} />
            <GraphToolTip color={"#FFD325"} label={"Admission"} />
            <GraphToolTip color={"#869877"} label={"Re-admission"} />
          </div>
        </div>

        <AdmissionOverviewGraph data={chartData} />
      </div>

      <div className="flex-row align-start justify-start g-1">
        <div className="w-half flex-col align-start justify-start g-1 p-2 pb-1 back-white radius-6">
          <div className="flex-row align-center justify-between radius-6">
            <Title style={{ fontSize: "17px" }}>Admission</Title>
            <div className="flex-row align-center justify-start g-05">
              <Title style={{ fontSize: "15px" }}>Status</Title>
              <button
                className="transparentBtn"
                style={{
                  border: "none",
                  padding: "none",
                  height: "1rem",
                  width: "1rem",
                }}
              >
                <Image src={CrossHoloIcon} alt="" />
              </button>
              <button
                className="transparentBtn"
                style={{
                  border: "none",
                  padding: "none",
                  height: "1rem",
                  width: "1rem",
                }}
              >
                <Image src={TickHoloIcon} alt="" />
              </button>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <Title style={{ fontSize: "15px" }}>Accept all</Title>
              <button
                className="transparentBtn"
                style={{
                  border: "none",
                  padding: "none",
                  height: "1rem",
                  width: "1rem",
                }}
              >
                <Image src={TickHoloIcon} alt="" />
              </button>
            </div>
          </div>
          <hr color="#e5e5e5" />
          <div
            className="w-full scroll-y pr-1"
            style={{ height: "50vh ", overflow: "scroll" }}
          >
            <table className="scrollableTable w-full">
              <thead>
                <tr>
                  <th className="color-grayColor">Students</th>
                  <th className="color-grayColor">Date</th>
                  <th className="color-grayColor">Class</th>
                  <th className="color-grayColor">status</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(10)].map((_, index) => {
                  return (
                    <tr>
                      <td>
                        <div className="flex-row align-center justify-start g-05">
                          <img
                            src={ProfileImage}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: "50%",
                            }}
                            alt=""
                          />
                          <div className="flex-col align-left justify-start">
                            <span className="t-13 poppins">
                              Md Rejuwanul Karim
                            </span>
                            <span className="t-11 color-grayColor poppins">
                              +91 9876543210
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="color-greenColor t-13">2 oct,25</td>
                      <td className="color-greenColor t-13">VII</td>

                      <td>
                        <div className="flex-row align-center justify-end g-05">
                          <button
                            className="transparentBtn"
                            style={{
                              border: "none",
                              padding: "none",
                              height: "1rem",
                              width: "1rem",
                            }}
                          >
                            <Image src={CrossHoloIcon} alt="" />
                          </button>
                          <button
                            className="transparentBtn"
                            style={{
                              border: "none",
                              padding: "none",
                              height: "1rem",
                              width: "1rem",
                            }}
                          >
                            <Image src={TickHoloIcon} alt="" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="w-half flex-col align-start justify-start g-1 p-2 pb-1 back-white radius-6">
          <div className="flex-row align-center justify-between radius-6">
            <Title style={{ fontSize: "17px" }}>Re-admission</Title>
            <div className="flex-row align-center justify-start g-05">
              <Title style={{ fontSize: "15px" }}>Status</Title>
              <button
                className="transparentBtn"
                style={{
                  border: "none",
                  padding: "none",
                  height: "1rem",
                  width: "1rem",
                }}
              >
                <Image src={CrossHoloIcon} alt="" />
              </button>
              <button
                className="transparentBtn"
                style={{
                  border: "none",
                  padding: "none",
                  height: "1rem",
                  width: "1rem",
                }}
              >
                <Image src={TickHoloIcon} alt="" />
              </button>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <Title style={{ fontSize: "15px" }}>Accept all</Title>
              <button
                className="transparentBtn"
                style={{
                  border: "none",
                  padding: "none",
                  height: "1rem",
                  width: "1rem",
                }}
              >
                <Image src={TickHoloIcon} alt="" />
              </button>
            </div>
          </div>
          <hr color="#e5e5e5" />
          <div
            className="w-full scroll-y pr-1"
            style={{ height: "50vh ", overflow: "scroll" }}
          >
            <table className="scrollableTable w-full">
              <thead>
                <tr>
                  <th className="color-grayColor">Students</th>
                  <th className="color-grayColor">Date</th>
                  <th className="color-grayColor">Class</th>
                  <th className="color-grayColor">status</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(10)].map((_, index) => {
                  return (
                    <tr>
                      <td>
                        <div className="flex-row align-center justify-start g-05">
                          <img
                            src={ProfileImage}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: "50%",
                            }}
                            alt=""
                          />
                          <div className="flex-col align-left justify-start">
                            <span className="t-13 poppins">
                              Md Rejuwanul Karim
                            </span>
                            <span className="t-11 color-grayColor poppins">
                              +91 9876543210
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="color-greenColor t-13">2 oct,25</td>
                      <td className="color-greenColor t-13">VII</td>

                      <td>
                        <div className="flex-row align-center justify-end g-05">
                          <button
                            className="transparentBtn"
                            style={{
                              border: "none",
                              padding: "none",
                              height: "1rem",
                              width: "1rem",
                            }}
                          >
                            <Image src={CrossHoloIcon} alt="" />
                          </button>
                          <button
                            className="transparentBtn"
                            style={{
                              border: "none",
                              padding: "none",
                              height: "1rem",
                              width: "1rem",
                            }}
                          >
                            <Image src={TickHoloIcon} alt="" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
